export const common = {
    languages: {
        pt_br: "pt-br",
        en_us: "en-us",
    },
    labels: {
        account: "Account",
        accounts: "Accounts",
        active: "Active",
        action: "Action",
        actions: "Actions",
        address: "Address",
        addresses: "Addresses",
        add: "Add {concat}",
        administrator: "Administrator",
        alert: "Alert",
        analyse: "Analysis",
        analysis: "Analyses",
        apply: "Apply",
        assistant: "Assistant",
        assistants: "Assistants",
        avatar: "Avatar",
        back: "Back",
        bigger: "Bigger",
        birthdate: "Birthdate",
        blog: "Blog",
        brand: "Brand",
        calc: "Calculation",
        calibration_date: "Calibration Date",
        cancel: "Cancel {concat}",
        canceled: "Canceled",
        canceleds: "Canceled",
        cep: "Postal Code",
        certificate: "Certificate",
        certificates: "Certificates",
        change_account: "Switch Account",
        city: "City",
        clean: "Clear",
        close: "Close",
        cnae: "CNAE",
        cnpj: "cnpj",
        cockpit: "Cockpit",
        code: "Code",
        company: "Company",
        companies: "Companies",
        complement: "Complement",
        condition: "Condition",
        conditions: "Conditions",
        concluded: "Completed",
        confirm: "Confirm",
        confirm_password: "Confirm Password",
        configs: "Settings",
        continue: "Continue",
        contact: "Contact",
        contacts: "Contacts",
        corporate_reason: "Corporate Name",
        country: "Country",
        currency: "Currency",
        cpf: "cpf",
        crew: "Team",
        deduct: "Deduct",
        date: "Date",
        dates: "Dates",
        days: "Days",
        day: "Day",
        delete: "Delete {concat}",
        description: "Description",
        details: "Details",
        district: "District",
        divide: "Divide",
        document: "Document",
        documents: "Documents",
        document_type: "Document Type",
        download: "Download",
        edit: "Edit {concat}",
        equal: "Equal",
        equipment: "Equipment",
        equipments: "Equipment",
        email: "Email",
        employee: "Employee",
        employees: "Employees",
        enter: "Login",
        exit: "Logout",
        expiration: "Expiration",
        expiration_date: "Expiration Date",
        evaluation: "Evaluation",
        evaluations: "Evaluations",
        fabrication: "Manufacture Date",
        fantasy_name: "Trade Name",
        field: "Field",
        fields: "Fields",
        file: "File",
        files: "Files",
        finish: "Finish",
        form: "Form",
        forms: "Forms",
        footer: "Footer",
        free: "Free",
        group: "Group",
        groups: "Groups",
        home: "Home",
        if: "If",
        inactive: "Inactive",
        invoices: "Invoices",
        info: "Info",
        infos: "Information",
        item: "Item",
        items: "Items",
        laboratory: "Laboratory",
        laboratories: "Laboratories",
        login: "Login",
        manager: "Manager",
        member: "Member",
        members: "Members",
        menu: "Menu",
        method: "Method",
        methods: "Methods",
        method_group: "Method Group",
        model: "Model",
        my_agenda: "My Schedule",
        my_account: "My Account",
        my_profile: "My Profile",
        name: "Name",
        new: "New {concat}",
        new_password: "New Password",
        next: "Next",
        next_calibration: "Next Calibration",
        number: "Number",
        number_of_employee: "Number of Employees",
        not: "No",
        observation: "Observation",
        observations: "Observations",
        open: "Open",
        option: "Option",
        options: "Options",
        order: "Order",
        other: "Other",
        page: "Page",
        pages: "Pages",
        password: "Password",
        pending: "Pending",
        phone: "Phone",
        plans: "Plans",
        play: "Start {concat}",
        position: "Position",
        positions: "Positions",
        price: "Price",
        print: "Print",
        progress: "Progress",
        qualification: "Qualification",
        qualifications: "Qualifications",
        question: "Question",
        questions: "Questions",
        refresh: "Refresh",
        registration: "Registration",
        registrations: "Registrations",
        register: "Register",
        required: "Required",
        remove: "Remove {concat}",
        report: "Report",
        reports: "Reports",
        role: "Role",
        sample: "Sample",
        samples: "Samples",
        save: "Save",
        search: "Search",
        sector: "Sector",
        send: "Send",
        serial_number: "Serial Number",
        service: "Service",
        services: "Services",
        setting: "Setting",
        settings: "Settings",
        showing: "Showing",
        signature: "Subscription",
        sign: "Subscribe",
        slug: "Slug",
        skill: "Skill",
        skills: "Skills",
        smaller: "Smaller",
        social_name: "Social Name",
        start: "Start",
        started: "Started",
        state: "State",
        status: "Status",
        stop: "Stop",
        subscriptions: "Subscriptions",
        subtitle: "Subtitle",
        sum: "Sum",
        summary: "Summary",
        technical: "Technician",
        technicals: "Technicians",
        termination: "Termination",
        term: "Term",
        terms: "Terms",
        title: "Title",
        titles: "Titles",
        time: "Time",
        total_duration: "Total Duration",
        type: "Type",
        upload: "Upload {concat}",
        user: "User",
        users: "Users",
        validity: "Validity",
        visible: "Visible",
        vacancy: "Vacancy",
        vacancies: "Vacancies",
        value: "Value",
        yacht: "Yacht",
        yachts: "Yachts",
        yes: "Yes",
    },
    placeholders: {
        code: "Enter the code",
        describe: "Describe",
        email: "Enter the email",
        login: "Enter your login",
        name: "Enter the name",
        order: "Enter the order",
        sector: "Enter the sector",
        password: "Enter your password",
        select: "Select...",
    },
    modals: {
        titles: {
            remove_avatar: "Remove Avatar",
        },
        messages: {
            remove_avatar: "Do you want to remove the <strong>AVATAR</strong>?<br/>This action cannot be undone!",
        },
    },
    texts: {
        no_results: "There are no results to display.",
        forgot_password: "Forgot your password?",
        recover_password: "Recover Password",
        already_account: "Already have an account?",
        dont_account: "Don't have an account?",
        register_account: "Register an account",
        remembered_password: "Remembered your password?",
        undo_message: "This operation cannot be undone!",
        item_message: "Added items will also be lost!",
        remove_message: "Do you want to remove <strong>''{concat}''</strong>?<br/>This action cannot be undone!",
        input_code: "Enter the code sent to your registered email below:",
        file_upload: "Select or drag the file to upload",
        model_download: "Download the template file",
        not_deletable: "The selected item cannot be removed!",
    }
};
